/**
 * Client-side badge slug validator (P1-7).
 *
 * Real slugs are lowercase alphanumeric + hyphen, 8–64 chars, neither
 * leading nor trailing with a dash. Anything outside this shape is
 * either an attacker probe or a typo — we short-circuit before any
 * network call so the API never sees garbage.
 *
 * Kept in /lib so it's testable in pure Node (no React / router deps).
 */

const VALID_SLUG_RE = /^[a-z0-9](?:[a-z0-9-]{6,62}[a-z0-9])$/;

export function isValidBadgeSlug(s) {
  return typeof s === "string" && VALID_SLUG_RE.test(s);
}
